import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

function useNotificationPreferences() {
    return useQuery('notification-preferences', () => new Client().notificationPreferences_GetNotificationPreferences())
}

export default useNotificationPreferences;